import { getLabelFromStorage } from '@pb/utils'

export const emptyHeading = getLabelFromStorage('styleboard.following.empty.title')
export const emptyText = getLabelFromStorage('styleboard.following.empty.text')
export const emptyButton = getLabelFromStorage('styleboard.following.empty.cta')

// Non logged in
export const nonLoggedInText = getLabelFromStorage('styleboard.log.in.to.explore')
export const nonLoggedInBodyText = getLabelFromStorage('styleboard.makes.it.easy')
export const nonLoggedInBtnText = getLabelFromStorage('styleboard.log.in')

// Popular Styleboard
export const popularStyleboardsHeading = getLabelFromStorage('styleboard.empty.following.section')
export const popularStyleboardsViewAll = getLabelFromStorage('styleboard.landingpage.view.all')
export const popularStyleboardsExplore = getLabelFromStorage(
  'styleboard.landingpage.explore.all.styleboards',
)
